/* eslint-disable @typescript-eslint/no-explicit-any */

import dayjs from 'dayjs';
import { Tour } from 'app/types';

interface YearData {
  [key: string]: number;
}

interface ChartDataFormat {
  name: string;
  Views: number;
}

interface ToursViewData {
  [key: string]: number;
}

export function getChartData(data: Tour[]): any {
  if (data.length === 0) {
    return [];
  }

  const chartDataObj = data.reduce((previousValue: any, currentValue): any => {
    if (!currentValue?.viewData) {
      return previousValue;
    }

    const days = Object.keys(currentValue?.viewData);

    days.forEach((day: any) => {
      if (previousValue.hasOwnProperty(day)) {
        previousValue[day] += currentValue.viewData[day];
      } else {
        previousValue[day] = currentValue.viewData[day];
      }
    });

    return previousValue;
  }, {});

  const chartData = Object.keys(chartDataObj).map((data) => ({
    [data]: chartDataObj[data],
  }));

  const sortDates = (dates: ToursViewData[]) => {
    return dates.sort((a, b) =>
      dayjs(Object.keys(a)[0]).isAfter(dayjs(Object.keys(b)[0])) ? 1 : -1,
    );
  };

  const sortedDates = sortDates(chartData);

  const generateEmptyDataObjects = (number: number) => {
    return Array.from(Array(number).keys()).map((_day, index) => {
      return {
        name: dayjs()
          .subtract(number - 1 - index, 'day')
          .format('ddd MMM DD YYYY'),
        Views: 0,
      };
    });
  };

  const generateLastYearObject = () => {
    const yearObj: YearData = {};

    Array.from(Array(12).keys()).forEach((_day, index) => {
      const monthName: string = dayjs()
        .subtract(12 - 1 - index, 'month')
        .format('MMM');
      yearObj[monthName] = 0;
    });

    return yearObj;
  };

  let lastWeekData: ChartDataFormat[] = generateEmptyDataObjects(7);
  let lastMonthData: ChartDataFormat[] = generateEmptyDataObjects(30);
  const yearsData: YearData = generateLastYearObject();

  sortedDates.forEach((data: ToursViewData) => {
    const date = Object.keys(data)[0];
    const dayJs = dayjs(date);

    lastWeekData = lastWeekData.map((day) => {
      if (day.name === date) {
        return { ...day, Views: data[date] };
      }

      return day;
    });

    lastMonthData = lastMonthData.map((day) => {
      if (day.name === date) {
        return { ...day, Views: data[date] };
      }

      return day;
    });

    const withinLastYear = dayJs.diff(dayjs(), 'year') === 0;

    if (withinLastYear) {
      const shortMonthName = dayJs.format('MMM');

      if (yearsData.hasOwnProperty(shortMonthName)) {
        yearsData[shortMonthName] += data[date];
      } else {
        yearsData[shortMonthName] = data[date];
      }
    }
  });

  const lastYearData: ChartDataFormat[] = Object.keys(yearsData).map(
    (month) => {
      return {
        name: month,
        Views: yearsData[month],
      };
    },
  );
  return [lastWeekData, lastMonthData, lastYearData];
}
